//
import Model from '@/models/Model'

/**
 * This class describes a change maximum customer credit.
 * @class AChangeMaxCustomerCredit (name)
 */
export default class AChangeMaxCustomerCredit extends Model {

	/**
	 * { function_description }
	 * @return {string} { description_of_the_return_value }
	 */
  resource() {
    return 'change_max_customer_credit'
  }
}
